export default {"src":"/_next/static/media/VendorIconRed.f2d81482.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};